import axios from 'axios';
import router from '@/router';

export default function jwtInterceptor() {
    axios.interceptors.request.use(function (config) {
        const token = localStorage.getItem('jwtToken');
        const whiteListedApi = ['mobile-users/auth', 'merchant-users/password','forgot-password','/merchant/user/password-reset','/merchant/user/password-create','merchants/signup'];
        const url = config.url;

        const isWhitelisted = whiteListedApi.some((checkurl) => {            
            return url.includes(`${checkurl}`);
        });

        if (!isWhitelisted && token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        return config;
    }, function (err) {
        return Promise.reject(err);
    });

    axios.interceptors.response.use(function (response) {
        return response
    }, function (err) {
        if (err.response && err.response.status === 401) {
            localStorage.removeItem('merchant');
            localStorage.removeItem('jwtToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('menuDisplayAuthorities');
            localStorage.removeItem('profileManagementAuthorities');
            router.push('/login')
        }

        const responseData = err.response && err.response.data ? err.response.data : {};
        const message = responseData.message || err.message || 'System Error!';
        const error = Object.assign(new Error(message), responseData);
        return Promise.reject(error)
    })
}
